// extracted by mini-css-extract-plugin
export var content = "_qt-1";
export var noScroll = "_qt-3";
export var paper = "_qt-0";
export var scrollable = "_qt-2";